module.exports = "/assets/data/80d1eef17b2f6260114b7396925df40f-NG17.data.json";